import * as React from "react"
import { Row, Col } from "react-grid-system"
import styled from "styled-components"
import { HorizontalSpacer } from "../../atoms/spacers"
import H1 from "../../atoms/typography/H1"
import PageContentWrapper from "../../organisms/PageContentWrapper"
import { theme } from "../../theme"
import { Link } from "react-router-dom"
import TextButton from "../../atoms/buttons/TextButton"

const DiscoverProductsStyle = styled.div`
  background-image: url("/static/img/background/mountain-backdrop.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`

const DiscoverProducts = () => {
  return (
    <DiscoverProductsStyle>
      <PageContentWrapper>
        <HorizontalSpacer spacing={5} />
        <H1 bold color={theme.colors.white}>
          Discover Satcube products
        </H1>
        <HorizontalSpacer spacing={2} />
        <Row justify="between">
          <Col xs={12} md="content">
            <Link to="/products/ku">
              <TextButton title="Satcube Ku" color={theme.colors.white} />
            </Link>
          </Col>
          <Col xs={12} md="content">
            <Link to="/products/secure">
              <TextButton title="Satcube Secure" color={theme.colors.white} />
            </Link>
          </Col>
          <Col xs={12} md="content">
            <Link to="/products/motion">
              <TextButton title="Satcube Motion" color={theme.colors.white} />
            </Link>
          </Col>
        </Row>
        <HorizontalSpacer spacing={5} />
      </PageContentWrapper>
    </DiscoverProductsStyle>
  )
}

export default DiscoverProducts
